import {
  GET_CONTACT,
  UPDATE_CONTACT,
  LOAD_CONTACT,
  RESET_CONTACTS,
  GET_SEGMENTS,
  SAVE_SEGMENTS,
} from "../constants/Contacts";

export const getContact = (data) => {
  return {
    type: GET_CONTACT,
    payload: data,
  };
};

export const saveContacts = (contact) => {
  return {
    type: LOAD_CONTACT,
    payload: contact,
  };
};

export const updateContact = (contact) => {
  return {
    type: UPDATE_CONTACT,
    payload: contact,
  };
};

export const resetContact = () => {
  return {
    type: RESET_CONTACTS
  };
};

export const getSegments = () => {
  return {
    type: GET_SEGMENTS
  };
}

export const saveSegments = (data) => {
  return {
    type: SAVE_SEGMENTS,
    payload: data
  };
}